import { AdminAppState, Image } from '../../state';
import { getImageEntry } from './get-image-entry';

export const getImage = (imageKey: string) => (state: AdminAppState): Image =>
  getImageEntry(imageKey)(state).image;
